import {DEFAULT_CURRENCY_CODE, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastModule} from "primeng/toast";
import {ExtendedModule, FlexModule} from "@angular/flex-layout";
import {IconService} from "@shared/services/icon.service";
import {CoreModule} from "./modules/core.module";
import {Angular2PromiseButtonModule} from "angular2-promise-buttons";
import {AppSharedModule} from './modules/app-shared/app-shared.module';
import {FullCalendarModule} from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import {NgcCookieConsentConfig, NgcCookieConsentModule} from "ngx-cookieconsent";
import {UrlService} from "@services/url.service";
import { MaintenanceComponent } from './maintenance/maintenance.component';

FullCalendarModule.registerPlugins([ // register FullCalendar plugins
    dayGridPlugin,
    interactionPlugin
]);

function getCookieConfig(){
    const urlService = new UrlService();
    const link = urlService.isSM() ? 'https://www.servicemasterclean.co.uk/cookies-policy/' : 'https://merrymaids.co.uk/cookies-policy/';
    const cookieConfig: NgcCookieConsentConfig = {
        cookie: {
            domain: window.location.hostname, //'localhost' // or 'your.domain.com' // it is mandatory to set a domain, for cookies to work properly (see https://goo.gl/S2Hy2A)
        },
        "position": "bottom",
        "theme": "classic",
        "palette": {
            "popup": {
                "background": "#000000",
                "text": "#ffffff",
                "link": "#ffffff"
            },
            "button": {
                "background": "#f1d600",
                "text": "#000000",
                "border": "transparent"
            }
        },
        "type": "info",
        elements: {
            messagelink: '<span id="cookieconsent:desc" class="cc-message">' +
                'We use cookies to give you the best possible experience on our site. By continuing to use the site you agree to our use of cookies.' +
                '<a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="' +
                link +
                '" target="_blank">Learn more</a>' +
                '</span>',
        },
    };
    return cookieConfig;
}

@NgModule({
    declarations: [
        AppComponent,
        MaintenanceComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CoreModule,
        BrowserAnimationsModule,
        ToastModule,
        FlexModule,
        Angular2PromiseButtonModule.forRoot(),
        AppSharedModule,
        NgcCookieConsentModule.forRoot(getCookieConfig()),
        ExtendedModule,
    ],
    providers: [
        {provide: DEFAULT_CURRENCY_CODE, useValue: 'GBP'},
        CoreModule
    ],
    exports: [],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(private iconService: IconService) {
        iconService.registerIcons();
    }
}
